import type { FC, NamedExoticComponent } from "react";
import { createComponentRegistry } from "../../../../../shared-logic/features/ComponentRegistry";
import type { SectionWrapperPropagationProps } from "./common/section-wrapper/SectionWrapper";
import type { Props } from "./common/header/BackButton";
import type { HeroProps } from "./highlights/sections/Hero";
import type { HighlightsHeroButtonProps } from "./highlights/HighlightsHeroButton";
import type { CarConfigConfigureSectionsLbx } from "../../utils/types/SectionTypesLbx";
import type { OverviewItemWrapperProps } from "./common/summary/overview/OverviewItemWrapper";

const { ComponentRegistryProvider, useComponentRegistry } = createComponentRegistry<{
    Summary: NamedExoticComponent;
    AtmosphereHero: NamedExoticComponent<SectionWrapperPropagationProps<CarConfigConfigureSectionsLbx>>;
    HeaderBackButton: FC<Props>;
    HeaderCta: FC;
    HighlightsHero: FC<HeroProps>;
    HighlightsHeroButton: FC<HighlightsHeroButtonProps>;
    ConfigCtas: FC;
    OverviewItemWrapper: FC<OverviewItemWrapperProps>;
}>();

export { ComponentRegistryProvider, useComponentRegistry };
